import {Component, OnInit, Input} from '@angular/core';
import {Loading, LoadingController, NavController} from 'ionic-angular';
import { RcsKdDataServiceProvider } from '../../providers/rcs-kd-data-service/rcs-kd-data-service';
import { RcsConnectorIndexDbProvider } from '../../providers/rcs-connector-index-db/rcs-connector-index-db';
import { JobCommitProvider } from '../../providers/job-commit/job-commit';
import {RcsStackDbProvider} from "../../providers/rcs-stack-db-service/rcs-stack-db-service";
import {StackService} from "../../providers/odoo/stack.service";

@Component({
  selector: 'rcs-kd-job-list',
  templateUrl: 'rcs-kd-job-list.html'
})
export class RcsKdJobListComponent implements OnInit{

  loading: Loading;
  @Input() jobs: Array<any>;
  private stack_ids: any;

  constructor(
    public loadingCtrl: LoadingController,
    public data_service: RcsKdDataServiceProvider,
    public db_service: RcsConnectorIndexDbProvider,
    public navCtrl: NavController,
    public job_commit: JobCommitProvider,
    public stack_db: RcsStackDbProvider,
    public stack: StackService,
  ) {}

  ngOnInit(): void {
    this.stack.observer.subscribe(() => {
      this.stack_db.get_stack_ids().subscribe(result => {
        this.stack_ids = result;
      })
    })
  }

  private getDescription(job:any) {
    if (job && job.description) {
      return job.description.replace(/\n/ig, '<br/>');
    } else {
      return '';
    }
  }

  public isJobBeginnenVisible() {
    return (localStorage.getItem('manual_sync_needed') === null);
  }

  public go_to_edit_page(job_id:any):void{
    this.db_service.get_record_by_key('jobs', job_id).subscribe(
      job => {
        this.navCtrl.push('JobPage', { job: job, page: 'HomePage'});
      }
    )
  }

  public start_job(job:any){
    this.loading = this.loadingCtrl.create({
      content: 'Status wird umgetragen'
    })
    job.state_name = 'in Arbeit';
    this.db_service.update_record('jobs', job, job.id).subscribe(() => {
      this.job_commit.signal_job_start(job).subscribe((updated_job) => {
        this.loading.dismiss();
        this.navCtrl.push('JobPage', { job: updated_job, type: 'execution', page: 'HomePage'});
      },
      () => {
        this.loading.dismiss();
        this.navCtrl.push('JobPage', { job: job, type: 'execution', page: 'HomePage'});
      })
    })
  }

  public push_replacement_page(id:string): void{
    this.navCtrl.setPages([{'page': 'ReplacementPartsPage', 'params': { job_id: id }}]);
  }

  public job_in_stack(job_id){
    if (this.stack_ids && this.stack_ids.indexOf(job_id) != -1){
      return true
    }else{
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/rcs-kd-job-list/rcs-kd-job-list.ts